function galleryInit() {
	
	var $galleryThumbsItem = document.querySelectorAll('.gallery-thumbs-item'), 
		$galleryThumbsItemOne = $galleryThumbsItem[0],
		$galleryBigItems = document.querySelectorAll('.gallery-big-item'),
		windowWidth = window.innerWidth,
		sidebarWidth = document.querySelector('.sidebar').offsetWidth;

	setTimeout(function(){
		$('.gallery-big-item').width($(window).width() - $('.sidebar').width());
	}, 200);

	$('.gallery-big').slick({
		infinite: true,
		speed: 1000,
		slidesToShow: 1,
		autoplay: true,
		autoplaySpeed: 3000,
		cssEase: 'cubic-bezier(0.75,0.25,0.25,1)',
		dots: false,
		variableWidth: true,
		arrows: true,
		fade: true,
		prevArrow: '<span class="slick-prev"></span>',
		nextArrow: '<span class="slick-next"></span>'
	});

	$('.gallery-thumbs').slick({
		slidesToShow: 12,
		slidesToScroll: 1,
		asNavFor: '.gallery-big',
		focusOnSelect: true,
		variableWidth: true,
		responsive: [{
		    breakpoint: 1280,
		    settings: {
		    	slidesToShow: 8
		    }
		}, 
		{
		    breakpoint: 768,
		    settings: {
		    	slidesToShow: 4
		    }
		},
		{
		    breakpoint: 480,
		    settings: {
		        slidesToShow: 1
		    }
		}]
	});

	$('.gallery-big').on('afterChange', function(event, slick, currentSlide, nextSlide){

		for (var i = 0; i < $galleryThumbsItem.length; i++) {
			$galleryThumbsItem[i].classList.remove('active');
		}

    	$('.gallery-thumbs-item').each(function(){
	    	if(this.getAttribute('data-slick-index') == currentSlide && !this.hasClass('slick-cloned') ) {
		    	this.classList.add('active');
	    	}
    	});
	});

	$galleryThumbsItemOne.classList.add('active');

};

module.exports = galleryInit;